import { defineStoryFunnel } from "./_story-funnel-schema";
import { BOOST_STORY_EFFECTS, buildBoostStoryOffer } from "./boost-story-shared";

export const boostAgeStory = defineStoryFunnel({
  kind: "story-funnel",
  slug: "boost-age-story",
  version: 2,
  effects: BOOST_STORY_EFFECTS,
  meta: { title: "Boost Age Story" },
  offer: { href: "https://mengotomars.com/pages/boost-pdp-age" },
  screens: [
    {
      "id": "hook",
      "role": "story",
      "layout": "image-overlay",
      "heading": "WHY DO YOU FEEL OLD\nWHEN YOU'RE NOT?",
      "contentTop": 370,
      "headingAccent": [
        "WHEN YOU'RE NOT?"
      ],
      "image": {
        "src": "/static/images/story-funnels/age-hook.webp",
        "alt": "Man sitting thoughtfully in a living room",
        "geometry": {
          "x": -45,
          "y": 49,
          "width": 420,
          "height": 385,
          "flipX": true
        },
        "fade": {
          "start": 330,
          "end": 377.566
        }
      },
      "blocks": [
        {
          "type": "paragraphs",
          "paragraphs": [
            "You used to feel like a rockstar.\nNow you're tired by 3 PM, your workouts hit harder, and your drive isn't what it used to be.",
            "You tell yourself it's \u201cjust getting older.\u201d",
            "But what if age is just the cover story?"
          ],
          "emphasis": [
            "But what if age is just the cover story?"
          ]
        },
        {
          "type": "rating",
          "stars": 5,
          "label": "4.8/5",
          "text": "5798 REVIEWS"
        }
      ],
      "cta": "WHY DO I FEEL LIKE THIS? \u2192"
    },
    {
      "id": "problem",
      "role": "story",
      "layout": "image-overlay",
      "heading": "IT’S LIKE LIFE IS\nSTUCK ON HARD MODE.",
      "contentTop": 334,
      "headingAccent": [
        "HARD MODE"
      ],
      "image": {
        "src": "/static/images/story-funnels/age-problem.webp",
        "alt": "Man sitting beside a sleeping woman",
        "geometry": {
          "x": -34,
          "y": 39,
          "width": 460,
          "height": 460
        },
        "fade": {
          "start": 172,
          "end": 533.606
        }
      },
      "blocks": [
        {
          "type": "paragraphs",
          "paragraphs": [
            "It's not just one thing. You wake up tired. Your strength is slipping. Your wife notices your drive is gone...\n\nYou barely recognize the man in the mirror staring back at you.",
            "And the worst part?",
            "You've started accepting it as normal."
          ],
          "emphasis": [
            "And the worst part?"
          ]
        }
      ],
      "cta": "FIND OUT WHAT\u2019S GOING ON \u2192"
    },
    {
      "id": "testosterone",
      "role": "story",
      "layout": "image-overlay",
      "heading": "AGING IS INEVITABLE.\nFEELING OLD IS OPTIONAL.",
      "contentTop": 157,
      "headingAccent": [
        "OPTIONAL"
      ],
      "image": {
        "src": "/static/images/story-funnels/age-testosterone.webp",
        "alt": "Man training in a gym",
        "geometry": {
          "x": -48,
          "y": -100,
          "width": 457,
          "height": 607
        },
        "fade": {
          "start": 102,
          "end": 508.172
        }
      },
      "blocks": [
        {
          "type": "paragraphs",
          "paragraphs": [
            "When you're young, you have the energy to do it all. Work hard, stay out late, and bounce right back.\n\nBut around age 30, testosterone levels can decline by roughly 1% every year.",
            "Testosterone is a main driver for:"
          ],
          "emphasis": [
            "Testosterone is a main driver for:"
          ]
        },
        {
          "type": "list",
          "items": [
            "\u26a1 Your energy and vitality",
            "\ud83d\udcaa Your muscle maintenance",
            "\ud83d\udd25 Your libido and drive",
            "\ud83c\udfcb\ufe0f Your strength and recovery"
          ]
        },
        {
          "type": "paragraphs",
          "paragraphs": [
            "Year after year, that decline starts to add up."
          ]
        }
      ],
      "cta": "WHAT CAN I DO ABOUT IT? \u2192"
    },
    {
      "id": "boost-timeline",
      "role": "story",
      "layout": "image-overlay",
      "heading": "YOUR SECOND PRIME STARTS NOW.",
      "contentTop": 189,
      "headingAccent": [
        "SECOND PRIME"
      ],
      "image": {
        "src": "/static/images/story-funnels/age-timeline.webp",
        "alt": "Man smiling after a workout",
        "geometry": {
          "x": 0,
          "y": 21,
          "width": 375,
          "height": 375
        },
        "fade": {
          "start": 121,
          "end": 361.646
        }
      },
      "blocks": [
        {
          "type": "paragraphs",
          "paragraphs": [
            "Meet Mars Men Boost. One complete formula. FOUR ways to support your testosterone health: MAKE MORE T, FREE YOUR T, PROTECT YOUR T, + OPTIMIZE IT.",
            "What could your next 90 days look like?"
          ],
          "emphasis": [
            "Mars Men",
            "What could your next 90 days look like?"
          ],
          "accent": [
            "Boost"
          ]
        },
        {
          "type": "timeline",
          "items": [
            {
              "label": "\u26a1 DAY 7:",
              "title": "IGNITION",
              "paragraphs": [
                "More energy, more spark."
              ]
            },
            {
              "label": "\ud83d\udd25 DAY 30:",
              "title": "SPARK",
              "paragraphs": [
                "Your drive comes roaring back."
              ]
            },
            {
              "label": "\ud83d\ude80 DAY 90:",
              "title": "LIFTOFF",
              "paragraphs": [
                "You\u2019re stronger, leaner, more masculine. Confidence becomes your new normal."
              ]
            }
          ]
        },
        {
          "type": "paragraphs",
          "paragraphs": [
            "Getting older doesn't mean giving up."
          ],
          "emphasis": [
            "Getting older doesn't mean giving up."
          ],
          "accent": [
            "Getting older doesn't mean giving up."
          ]
        }
      ],
      "cta": "LET\u2019S SEE THE PROOF \u2192"
    },
    {
      "id": "reviews",
      "role": "story",
      "layout": "image-overlay",
      "heading": "4.78 Stars.\n503,128+ MEN\nON MARS",
      "contentTop": 179,
      "headingAccent": [
        "4.78",
        "503,128+"
      ],
      "image": {
        "src": "/static/images/story-funnels/age-reviews.webp",
        "alt": "Man drinking coffee in a kitchen",
        "geometry": {
          "x": 0,
          "y": 0,
          "width": 375,
          "height": 343,
          "flipX": true
        },
        "fade": {
          "start": 73,
          "end": 344.204
        }
      },
      "blocks": [
        {
          "type": "reviews",
          "items": [
            {
              "id": "dan-g",
              "rating": 5,
              "heading": "Doctor Called It His 'Fountain of Youth'...His Wife Agrees",
              "paragraphs": [
                "\u201cThis has helped me get back into my 20-30s my energy levels are better my sleep is great blood sugar all my levels are good. Doc said I found a fountain of youth! My wife truly enjoys our morning and late nights, if she could leave a review I\u2019m sure she would! So yeah buddy\u201d"
              ],
              "author": "Dan G.",
              "verified": true
            },
            {
              "id": "thomas-e",
              "rating": 5,
              "heading": "Lost 100lbs and Found His Manhood Again at 51",
              "paragraphs": [
                "\u201cI've gotten my life back after many years. Mars Men was a huge part of that journey. I've lost 100lbs regaining my manhood, and feeling better than I have since my 30s, 51 now. More energy and more zest for life. I'm on my second 90 day supply and no plans on stopping anytime soon.\u201d"
              ],
              "author": "Thomas E.",
              "verified": true
            },
            {
              "id": "samuel-g",
              "rating": 5,
              "heading": "I Regret Not Starting Sooner",
              "paragraphs": [
                "\u201cI've been sleeping like a rock and waking up before my alarm, like I was back in my 20s with my third leg pointing up lol. I\u2019ve had so much energy lately. I'm constantly going up on weight and muscle is definitely starting to show. I'm only finishing up on my 2nd month right now, and I'm truly satisfied. I recommend it to every man out there. It will change your life.\u201d"
              ],
              "author": "Samuel G.",
              "verified": true
            },
            {
              "id": "robb-k",
              "rating": 5,
              "heading": "After 15 Years, My Body Feels Like It's Aging Backwards",
              "paragraphs": [
                "\u201cI gave this product the time to work that the Mars Men team advised, and the results have been tremendous.\u00a0 My body actually feels like I'm aging backwards. And for the last 15 years I've been dealing with a case of \"morning wouldn't,\" and now it's a The Little Engine That Can every day.\u00a0 Thank you for an amazing product.\u201d"
              ],
              "author": "Robb K.",
              "verified": true
            }
          ]
        }
      ],
      "cta": "ALRIGHT, SHOW ME THE DEAL \u2192"
    },
    buildBoostStoryOffer(),
  ],
});
